/**
 * Green Flag — layer styles
 *
 * Named surface presets for layered UI (bg + shadow + radius + border).
 * Applied with `layerStyle="card"`.
 */

import { defineLayerStyles } from "@chakra-ui/react";

export const layerStyles = defineLayerStyles({
  card: {
    description: "Default event/match card surface — barely-there lift.",
    value: {
      bg: "bg.canvas",
      borderRadius: "sm",
      boxShadow: "card",
    },
  },
  imageTile: {
    description: "Image container inside a card or carousel.",
    value: {
      borderRadius: "xs",
      boxShadow: "image",
      overflow: "hidden",
    },
  },
  floating: {
    description: "Floating circular action button (swipe yes/no).",
    value: {
      bg: "bg.canvas",
      borderRadius: "full",
      boxShadow: "lift",
    },
  },
  heroBand: {
    description: "Flat solid green hero band at the top of Home screens.",
    value: {
      bg: "bg.brand",
      color: "fg.onBrand",
    },
  },
});
